const CART_API_URL = `${window.webAppBase}/cart`;

const syncLegacyCartToShopify = async (identityId, token) => {
  deleteCookie("identityId");
  try {
    const res = await fetch(CART_API_URL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "x-fp-identityid": identityId,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!res.ok) {
      return [];
    }

    const text = await res.text();
    if (!text) {
      return [];
    }

    let legacyCart;
    try {
      legacyCart = JSON.parse(text);
    } catch (err) {
      return [];
    }

    if (!Array.isArray(legacyCart) || legacyCart.length === 0) {
      return [];
    }

    const items = legacyCart.flatMap((item) => {
      return item.variant_id && !item.sold_out && (!item.hold_status || item.hold_status === "None")
        ? [
            {
              id: item.variant_id,
              quantity: item.quantity,
            },
          ]
        : [];
    });

    if (items.length === 0) {
      return [];
    }

    return items;
  } catch (error) {
    console.error("Error during cart sync:", error);
    return [];
  }
};
